import { render, staticRenderFns } from "./medidas-preventivas-editar.vue?vue&type=template&id=34d6231c&"
import script from "./medidas-preventivas-editar.vue?vue&type=script&lang=js&"
export * from "./medidas-preventivas-editar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports